<template>
  <div>
    <vue-cal
        @cell-click="(d) => {selectedDate=d; showDateSelectionModal=true; setSlotsForDateScheduleModal();}"
        style="height: 65vh"
        :time="true"
        active-view="month"
        :disable-views="['years', 'year', 'week', 'day', ]"
        today-button
        :events="doctorschedules"
        :min-date="minDate"
        :max-date="maxDate"
    >
      <template v-slot:today-button>
        <b-button v-if="canAddAppointmentToDate" variant="light" squared @click="showScheduleModal = true">
          add

          <!--    form to add date to appointments date-->
          <b-modal id="modal-center" v-model="showScheduleModal" centered title="Add Appointment Time">
            <h2>Selected Date: {{ formattedSelectedDate }}</h2>
            <b-form>

              <!--        <b-form-group id="max_appointments_per_day" label="Number of appointments:" label-for="max_appointments_per_day"-->
              <!--                      description="maximum number of appointments.">-->
              <!--          <b-form-input id="max_appointments_per_day" type="text" required-->
              <!--                        v-model="doctorschedule_form.max_appointments_per_day"-->
              <!--                        placeholder="Enter maximum number of appointments"></b-form-input>-->
              <!--        </b-form-group>-->

              <b-row>
                <b-col>
                  <div>
                    <b-form-group id="start_time" label="Start Time :" label-for="start_time">
                      <vue-timepicker id="start_time" v-model="modalStartTime" format="HH:mm"/>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col>
                  <b-form-group id="end_time_group" label="End Time :" label-for="end_time">
                    <vue-timepicker id="end_time" v-model="modalEndTime" format="HH:mm"/>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>

            <template v-slot:modal-footer>
              <b-button size="sm" variant="success" @click="addAppointmentDate">
                Confirm
              </b-button>
              <b-button size="sm" variant="danger" @click="showScheduleModal = false">
                Cancel
              </b-button>

            </template>
          </b-modal>
          <!--    form to add date to appointments date-->
        </b-button>

        <!--        <b-button variant="light" squared @click="moveToCurrentDate">-->
        <!--          today-->
        <!--        </b-button>-->
      </template>
    </vue-cal>

    <b-modal id="date-schedule" v-model="showDateSelectionModal" centered title="Schdule For Selected Date" @hide="cancel">
      <h4 align="center">{{formattedSelectedDate}}</h4>
      <b-row flex v-if="slotstaken!==null" style="margin: 10px;">
        <div v-for="slots in slotstaken" :key="slots.time" >
          <b-button class="appiontmentButton" :variant="slots.status===0 ? 'success' : 'danger' " style="margin: 5px; font-weight: bold;" disabled>
            {{makeTimeAmPm(slots.time)}}
          </b-button>
        </div>
      </b-row>

      <h5 v-if="slotstaken===null"> No Schedule Is selected</h5>

      <template v-slot:modal-footer>
        <b-button variant="success" @click="dateScheduleMOdalAdd">
          ADD
        </b-button>
        <b-button variant="danger" @click="cancel">
          Cancel
        </b-button>

      </template>
    </b-modal>

  </div>
</template>

<script>
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import moment from 'moment'
import {Form} from "vform";
import {mapGetters} from 'vuex';

import AppointmentService from '../../../services/doctor/appointment.service';

export default {
  name: "Calendar",
  components: {
    'vue-cal': VueCal,
    VueTimepicker
  },
  data() {
    return {
      selectedDate: new Date(),
      showScheduleModal: false,
      showDateSelectionModal: false,

      schedulestaken: null,
      slotstaken: null,

      doctorschedules: [
        // {
        //   start: '2020-08-04 14:00',
        //   end: '2020-08-04 18:00',
        //   title: 'Need to go shopping',
        //   icon: 'shopping_cart', // Custom attribute.
        //   class: 'event_card'
        // }
      ],
      modalStartTime: '',
      modalEndTime: '',
      doctorschedule_form: new Form({
        doctor_id: '',
        max_appointments_per_day: '',
        start_time: '',
        end_time: '',
      }),
    }
  },
  computed: {
    ...mapGetters('doctorAuth', ['getUser']),
    canAddAppointmentToDate() {
      return true
    },
    formattedSelectedDate() {
      return moment(String(this.selectedDate)).format('DD/MM/YYYY')
    },
    ...mapGetters('doctorAuth', ['getUser']),

    minDate: () => {
      return new Date();
    },
    maxDate: () => {
      return new Date().addDays(29);
    },

  },
  methods: {
    fetchDoctorSchedules() {
      AppointmentService.fetchDoctorSchedules(this.getUser.doctor.id)
          .then((response) => {
            if (response.status === 200) {
              this.schedulestaken = response.data;
              let schedules = response.data;
              this.doctorschedules = [];
              schedules.forEach((schedule) => {
                JSON.parse(schedule.schedule_slots).forEach((slot) => {
                  // console.info(slot);
                  this.doctorschedules.push({
                    start: moment(slot.time).format("YYYY-MM-DD HH:mm"),
                    end: moment(slot.time).add(19, 'minutes').format("YYYY-MM-DD HH:mm"),
                    title: 'Appointment',
                  })
                })

              })
            }
          })
          .catch((e) => {
            console.log(e);
          })
    },


    addAppointmentDate() {
      let start = this.modalStartTime.split(':');
      let end = this.modalEndTime.split(':');
      this.doctorschedule_form.start_time = new Date(this.selectedDate.getTime());
      this.doctorschedule_form.end_time = new Date(this.selectedDate.getTime());
      this.doctorschedule_form.start_time.setHours(parseInt(start[0]), parseInt(start[1]));
      this.doctorschedule_form.start_time = moment(String(this.doctorschedule_form.start_time)).format("YYYY-MM-DDTHH:mm:ss.SZ");
      this.doctorschedule_form.end_time.setHours(parseInt(end[0]), parseInt(end[1]))
      this.doctorschedule_form.end_time = moment(String(this.doctorschedule_form.end_time)).format("YYYY-MM-DDTHH:mm:ss.SZ");

      AppointmentService.createDoctorSchedule(this.doctorschedule_form)
          .then((response) => {
            if (response.status === 201) {
              this.modalEndTime = '';
              this.modalStartTime = '';
              this.doctorschedule_form.clear();
              this.showScheduleModal = false;
              this.fetchDoctorSchedules();
            }
          })
          .catch((e) => {
            console.log(e);
          })
    },

    setSlotsForDateScheduleModal(){
      let selected_date = moment(String(this.selectedDate)).format('DD/MM/YYYY');
      this.schedulestaken.forEach((schedule) => {
        let date = moment(String(schedule.start_time)).format('DD/MM/YYYY');
        if(selected_date===date){
          console.log("date matched");
          this.slotstaken = JSON.parse(schedule.schedule_slots);
        }
      })
    },


    dateScheduleMOdalAdd(){
      this.cancel();
      this.showScheduleModal = true;
    },

    cancel(){
      this.showDateSelectionModal = false;
      this.slotstaken=null;
      // this.selectedDate=null;
    },

    makeTimeAmPm(time){
      let temp = moment(time,). format('LLLL');
      let temptime = temp.split(' ')[4];
      let format = temp.split(' ')[5];

      return `${temptime} ${format}`;
    },

  },
  mounted() {
    this.doctorschedule_form.doctor_id = this.getUser.doctor.id;
    this.fetchDoctorSchedules();
  }
}
</script>

<style src="./Calendar.scss" lang="scss">

</style>
